"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _chevronDown = _interopRequireDefault(require("../../assets/icons/chevron-down.svg"));

var _chevronUp = _interopRequireDefault(require("../../assets/icons/chevron-up.svg"));

var _constants = require("./constants");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExpandRowIcon = function ExpandRowIcon(_ref) {
  var _ref$isExpanded = _ref.isExpanded,
      isExpanded = _ref$isExpanded === void 0 ? false : _ref$isExpanded,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick;
  return /*#__PURE__*/_react.default.createElement("img", {
    className: _constants.classes.expandRowIcons,
    src: isExpanded ? _chevronUp.default : _chevronDown.default,
    onClick: onClick
  });
};

ExpandRowIcon.propTypes = {
  isExpanded: _propTypes.default.bool,
  onClick: _propTypes.default.func
};
var _default = ExpandRowIcon;
exports.default = _default;